module.exports = __webpack_public_path__ + "img/login-3.64b9b443.png";